import axios from '../service/axios/axios'

export default {
  // 获取调理分类列表
  getConditioningCategoryList(data) {
    return axios({
      method: 'post',
      url: 'platform/Conditioning/getConditioningCategoryList',
      data,
    })
  },
  // 获取调理分类详情
  getConditioningCategoryInfo(data) {
    return axios({
      method: 'post',
      url: 'platform/Conditioning/getConditioningCategoryInfo',
      data,
    })
  },
  // 修改分类排序
  editConditioningCategorySort(data) {
    return axios({
      method: 'post',
      url: 'platform/Conditioning/editConditioningCategorySort',
      data,
    })
  },
  // 添加调理分类
  saveConditioningInfo(data) {
    return axios({
      method: 'post',
      url: 'platform/Conditioning/saveConditioningInfo',
      data,
    })
  },
  // 编辑调理分类
  editConditioningInfo(data) {
    return axios({
      method: 'post',
      url: 'platform/Conditioning/editConditioningInfo',
      data,
    })
  },
  // 删除调理分类
  deleteConditioningInfo(data) {
    return axios({
      method: 'post',
      url: 'platform/Conditioning/deleteConditioningInfo',
      data,
    })
  }
}
